export default "__VITE_ASSET__6jR23Y4X__"